<template>
  <div class="top-bar">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 col-sm-12 mb-2 mb-md-0">
          <div class="top-bar-item">
            <i class="fas fa-phone-alt"></i>
            <span>(214) 888-9000</span>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 text-md-right text-center">
          <div class="top-bar-links">
            <router-link to="/member-dashboard" class="top-bar-link">
              Acceso a Miembros
            </router-link>
            <span class="separator">|</span>
            <router-link to="/insurance-agent/dashboard" class="top-bar-link">
              Acceso a Agentes
            </router-link>
            <span class="separator">|</span>
            <a href="/providers#form-section" class="top-bar-link" @click.prevent="goToProvidersForm">
              Registro de Agentes
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scrollToProvidersForm from '@/view/pages/landings/mixins/scrollToProvidersForm'

export default {
  name: "TopBar",
  mixins: [scrollToProvidersForm]
};
</script>

<style lang="scss" scoped>
@import '../../pages/landings/styles/variables';

.top-bar {
  background: $landing-primary-color; // Navy sólido mockup, sin degradado cyan
  color: white;
  padding: 14px 0;
  font-size: 1.2rem;
  position: sticky;
  top: 0;
  z-index: 1001;
  box-shadow: 0 2px 10px $landing-primary-rgba-15;

  @media (max-width: 991px) {
    display: none;
  }
  
  .top-bar-item {
    display: flex;
    align-items: center;
    gap: 12px;
    
    i {
      font-size: 1.15rem;
      opacity: 0.95;
    }
    
    span {
      font-weight: 600;
      font-size: 1.25rem;
      letter-spacing: 0.3px;
    }
  }
  
  .top-bar-links {
    display: flex;
    align-items: center;
    gap: 0;
    flex-wrap: nowrap;
    justify-content: flex-end;
    white-space: nowrap;
    
    .top-bar-link {
      color: white;
      text-decoration: none;
      font-weight: 600;
      font-size: 1.2rem;
      transition: all 0.3s ease;
      white-space: nowrap;
      padding: 0 6px;
      letter-spacing: 0.2px;
      
      &:hover {
        opacity: 0.9;
        text-decoration: underline;
        transform: translateY(-1px);
      }
    }
    
    .separator {
      opacity: 0.7;
      margin: 0 10px;
      font-size: 1.1rem;
      color: rgba(255, 255, 255, 0.7);
    }
  }
  
  @media (max-width: 991px) {
    .top-bar-links {
      flex-wrap: wrap;
      justify-content: center;
      gap: 4px;
      
      .separator {
        margin: 0 4px;
      }
    }
  }
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    padding: 12px 0;
    
    .top-bar-item {
      justify-content: center;
      margin-bottom: 8px;
      
      span {
        font-size: 1.1rem;
      }
    }
    
    .top-bar-links {
      justify-content: center;
      flex-wrap: wrap;
      gap: 4px;
      margin-top: 8px;
      
      .top-bar-link {
        font-size: 1.05rem;
        padding: 2px 4px;
      }
      
      .separator {
        margin: 0 4px;
        font-size: 1rem;
      }
    }
  }
  
  @media (max-width: 576px) {
    .top-bar-links {
      flex-direction: column;
      align-items: center;
      gap: 6px;
      
      .separator {
        display: none;
      }
      
      .top-bar-link {
        padding: 4px 0;
      }
    }
  }
}
</style>


